// Voice-input one-liner — audit FIT / D1.2.
// Surfaces the "voice input with live transcription on all four
// assistants" differentiator one level up from /assistants.
// Exact phrasing taken from the audit action-plan item
// "Add voice input to the homepage story".

import { Link } from "react-router-dom";
import { Mic, ArrowRight } from "lucide-react";

export default function VoiceInputCallout() {
  return (
    <section
      className="zy-section"
      aria-labelledby="voice-input-title"
      data-testid="voice-input-callout"
      style={{ paddingTop: 48, paddingBottom: 48 }}
    >
      <div className="max-w-5xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-5 rounded-2xl border border-[#eef1f7] bg-white px-7 py-6">
          <span
            aria-hidden="true"
            className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#202B60]/10 text-[#202B60] shrink-0"
          >
            <Mic size={22} />
          </span>
          <div className="flex-1 min-w-0">
            <h2
              id="voice-input-title"
              className="text-[18px] font-semibold text-[#0A1628] leading-snug"
            >
              Speak instead of type. Dictate your prompt and the four AI
              specialists transcribe it into chat.
            </h2>
            <p className="mt-1 text-[13.5px] text-[#0A1628]/60">
              Flour on your hands? Hands-free voice input is built into
              every assistant — live transcription, automatic send on
              pause.
            </p>
          </div>
          <Link
            to="/assistants#voice"
            data-testid="voice-input-link"
            className="inline-flex items-center gap-1.5 text-[13.5px] font-semibold text-[#202B60] hover:text-[#0A1628] whitespace-nowrap"
          >
            See how it works
            <ArrowRight size={14} />
          </Link>
        </div>
      </div>
    </section>
  );
}
